import { createContext } from 'react';

const OneTrustContextInitialValues = {
    loading: true,
    initialized: false,
    hasPerformance: false,
    hasFunctional: false,
    hasTargeting: false
};
const OneTrustContext = createContext(OneTrustContextInitialValues);

export { OneTrustContext, OneTrustContextInitialValues };
//# sourceMappingURL=context.js.map
